import './empty-state.scss';

export { default } from './EmptyState';
